/*\
|*|
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  Revision #1 - September 4, 2014
|*|
|*|  https://developer.mozilla.org/en-US/docs/Web/API/window.document.cookie
|*|  https://developer.mozilla.org/User:fusionchess
|*|  https://github.com/madmurphy/cookies.js
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path[, domain]])
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|
\*/

module.exports = {
  getItem: function getItem(sKey) {
    if (!sKey) {
      return null;
    }
    if (typeof window === "undefined" || !window.document) return null;
    return decodeURIComponent(window.document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*".concat(encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&"), "\\s*\\=\\s*([^;]*).*$)|^.*$")), "$1")) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (typeof window === "undefined" || !window.document) return null;
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=".concat(vEnd);
          break;
        case String:
          sExpires = "; expires=".concat(vEnd);
          break;
        case Date:
          sExpires = "; expires=".concat(vEnd.toUTCString());
          break;
      }
    }
    window.document.cookie = "".concat(encodeURIComponent(sKey), "=").concat(encodeURIComponent(sValue)).concat(sExpires).concat(sDomain ? "; domain=".concat(sDomain) : "").concat(sPath ? "; path=".concat(sPath) : "").concat(bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (typeof window === "undefined" || !window.document) return null;
    if (!this.hasItem(sKey)) {
      return false;
    }
    window.document.cookie = "".concat(encodeURIComponent(sKey), "=; expires=Thu, 01 Jan 1970 00:00:00 GMT").concat(sDomain ? "; domain=".concat(sDomain) : "").concat(sPath ? "; path=".concat(sPath) : "");
    return true;
  },
  hasItem: function hasItem(sKey) {
    if (typeof window === "undefined" || !window.document) return null;
    if (!sKey) {
      return false;
    }
    return new RegExp("(?:^|;\\s*)".concat(encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&"), "\\s*\\=")).test(window.document.cookie);
  },
  keys: function keys() {
    if (typeof window === "undefined" || !window.document) return [];
    var aKeys = window.document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  },
  hasOptedOutOfCookies: function hasOptedOutOfCookies() {
    // cookies set by onetrust, 1-4 should not get log cookie set
    // onetrust provides a groups param in the form "groups=C0001:1,C0002:0,..." etc
    // if any have a value of 0, they have opted out of that cookie
    // in case above, opted in to strinctly necessary, opted out of performance
    // ID C0001 Strictly Necessary Cookies
    // ID C0002 Performance Cookies
    // ID C0003 Functional Cookies
    // ID C0004 Targeting Cookies
    // ID C0005 Social Media Cookies

    var optanon = module.exports.getItem("OptanonConsent");
    if (!optanon) return false;
    var params = new URLSearchParams(optanon);
    var groupsParam = params.get("groups");
    if (!groupsParam || !groupsParam.includes("C0002")) {
      return true;
    }
    return !!groupsParam.includes("C0002:0");
  }
};